import { useContext, useEffect, useState } from "react";
import axios from "axios";
// import { generatePresignedUrl } from "./SignedUrl";
import { saveAs } from "file-saver";
import { SchoolContext } from "../context/SchoolContext";
import { CsvDownload, InfoModal } from "../commons/BaseModal";
import { formatValue, formatValueDetail, idExists } from "./NumberUtils";
import { useHistory } from "react-router-dom";
import { getAnnouncements } from "../api/api";

const Download = ({
  daterange,
  changeDate,
  deviceId,
  graphData,
  dayDetail,
}) => {
  const { schoolList, message, setMessage } = useContext(SchoolContext);
  const [openModal, setOpenModal] = useState(false);
  const authToken = localStorage.getItem("accessToken");
  const [tableData, setTableData] = useState();
  const [name, setName] = useState(null);
  const [loading, setLoading] = useState(false);
  const toggleModal = () => setOpenModal(!openModal);
  const history = useHistory();
  const pathname = history["location"].pathname;
  const id = Number(pathname.split("/").pop());
  const [status, setStatus] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [statusMsg, setstatusMsg] = useState();

  useEffect(() => {
    if (
      daterange === "min" &&
      dayDetail !== undefined &&
      Object.keys(dayDetail).length === 0
    ) {
      setStatus(true);
    } else {
      if (graphData !== undefined && Object.keys(graphData).length === 0) {
        setStatus(true);
      }
    }
  }, [daterange, dayDetail, graphData]);

  useEffect(() => {
    getCsv();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  const downloadData = async (e) => {
    setLoading(true);
    setOpenModal(false);
    if (e === "year" || e === "default" || e === "min") {
      setOpenModal(false);
      setLoading(false);
      if (e === "min") {
        setName(
          schoolList &&
            idExists(schoolList, id) &&
            schoolList[id - 1].official_name + "_" + changeDate + "_1minute"
        );
        setTableData({
          日時: dayDetail.datetime,
          "需要電力[kW]": dayDetail.demand_power,
          "発電電力[kW]": dayDetail.pv_power,
          "買電力(+)/売電力(-)[kW]": dayDetail.mmr_power,
          "蓄電池放電電力(+)/蓄電池充電電力(-)[kW]": dayDetail.bt_power,
          "SOC[%]": dayDetail.soc,
          "消費電力[kW]": dayDetail.consumption_power,
          "日射強度[kW/m²]": dayDetail.solar_radiation,
          "温度[°C]": dayDetail.temperature,
          通信エラー機器: dayDetail.com_error_device,
        });
      } else {
        setTableData({
          日時: graphData.datetime,
          "需要電力量[kWh]": graphData.demand_power,
          "発電量[kWh]": graphData.power_gene_str,
          "買電量[kWh]": graphData.recv_power,
          "売電量[kWh]": graphData.trans_power,
          "蓄電池放電量[kWh]": graphData.dischrg_power,
          "蓄電池充電量[kWh]": graphData.chrg_power,
          "蓄電池充電率[%]": graphData.soc,
          "消費電力量[kWh]": graphData.consumption_power,
          "日射量[kWh/m²]": graphData.solar_radiation,
          "温度[°C]": graphData.temperature,
          通信エラーデバイス: graphData.com_error_device,
        });
      }
    } else {
      setStatus(true);
      setOpenInfo(true);
      setstatusMsg(
        "CSVファイルの作成中です。\n完了後にダウンロード通知がお知らせに追加されます。"
      );
      const content = e.includes("detail") ? "detail" : "outline";
      const format = e.includes("detail") ? e.replace("_detail", "") : e;
      axios
        .get("/place/data/csv", {
          /// Prod Environment Endpoint
          // axios.get('https://q0y6zwaoj3.execute-api.ap-northeast-1.amazonaws.com/dev/place/data/csv', {  /// Dev Environment Endpoint
          params: {
            sems_device_id: deviceId,
            date: changeDate,
            period: daterange,
            content: content,
            output_format: format,
          },
          headers: {
            Authorization: authToken,
          },
        })
        .then((res) => {
          setStatus(false);
          if (res.data && res.data !== null) {
            setOpenInfo(true);
            setstatusMsg(
              "CSVファイルの作成中です。\n完了後にダウンロード通知がお知らせに追加されます。"
            );
            const prevMessage = message;
            let announcementCount = 0; // Counter for the number of retries
            const authToken = localStorage.getItem("accessToken");
            const placeId = schoolList[id - 1].place_id;

            const announcementInterval = setInterval(async () => {
              try {
                const response = await getAnnouncements(authToken, placeId);
                if (
                  response.data &&
                  response.data.length > prevMessage.length
                ) {
                  setMessage(response.data);
                  // setLoading(false);
                  // setOpenModal(false);
                  clearInterval(announcementInterval);
                } else {
                  announcementCount++;
                  if (announcementCount >= 6) {
                    clearInterval(announcementInterval);
                    // setLoading(false);
                    // setOpenModal(false);
                  }
                }
              } catch (error) {
                console.error("Error fetching announcements:", error);
                clearInterval(announcementInterval);
                // setLoading(false);
                // setOpenModal(false);
              }
            }, 10000);

            // setTimeout(() => {
            //     setLoading(false);
            // }, 3000);

            // const fetchData = async () => {
            //     try {
            //         // Call the generatePresignedUrl function
            //         const url = await generatePresignedUrl(fileName);

            //         // Download the file using the generated URL
            //         if (url.url && url.url.length) {
            //             setLoading(false);
            //             setOpenModal(false)
            //             window.location.href = url.url;
            //         }
            //     } catch (err) {
            //         console.error('Error generating pre-signed URL:', err);
            //     }
            // };

            // fetchData();
          }
        })
        .catch((err) => {
          console.log("err", err);
          setOpenInfo(true);
          setstatusMsg(
            "CSVファイルの作成に失敗しました。\nもう一度お試しください。"
          );
          setLoading(false);
          setStatus(false);
        });
    }
  };

  const getCsv = () => {
    const filename =
      name !== null
        ? name
        : schoolList &&
          idExists(schoolList, id) &&
          schoolList[id - 1].official_name + "_" + changeDate;
    if (tableData) {
      let tempBody = [];
      let tmpHeader = [];
      Object.keys(tableData).forEach((k) => {
        tmpHeader.push(k);
      });
      Object.keys(tableData["日時"]).forEach((value, index) => {
        tempBody.push(
          tmpHeader.map((v, i) => {
            if (Array.isArray(tableData[v][index])) {
              return tableData[v][index].toString().replaceAll(",", ";");
            } else {
              if (
                v === "日時" ||
                v === "蓄電池充電率[%]" ||
                v === "SOC[%]" ||
                v === "温度[°C]" ||
                v === "通信エラーデバイス"
              ) {
                return tableData[v][index];
              } else {
                if (daterange === "min") {
                  return formatValueDetail(tableData[v][index]);
                } else {
                  return formatValue(tableData[v][index]);
                }
              }
            }
          })
        );
      });
      // const csv = [tmpHeader.map((k, i) => { return (k.replace("k", "")) })].concat(tempBody).join('\r\n');
      const csv = [
        tmpHeader.map((k, i) => {
          return k;
        }),
      ]
        .concat(tempBody)
        .join("\r\n");
      saveAs(
        new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csv], {
          type: "text/csv, charset=utf-8",
        }),
        `${filename}.csv`
      );
      setName(null);
      setTableData();
    }
  };

  useEffect(() => {
    const favicon = document.querySelector("link[rel~='icon']");
    if (loading) {
      favicon.href = "/img/loading.gif";
    } else {
      favicon.href = "/favicon-3.ico";
    }
  }, [loading]);

  const toggleOpenInfo = () => {
    setOpenInfo(!openInfo);
    setstatusMsg();
  };

  return (
    <>
      <button
        className="justify-content-center download__btn"
        disabled={status}
        onClick={() => {
          if (daterange === "day" || daterange === "month") {
            toggleModal();
          } else {
            downloadData(daterange);
          }
        }}
      >
        <img
          src="/img/download.png"
          height="25px"
          alt="download"
          className="px-1 mb-1 mr-1"
        />
        ダウンロード
      </button>

      <CsvDownload
        open={openModal}
        handleOpen={toggleModal}
        content={`${
          !status
            ? "CSVデータの時間間隔を選択してください。"
            : "CSV is in Progress, Download link will appear in Notice"
        }`}
        text1="30分"
        text2="1分値(詳細)"
        text3="30分値(詳細)"
        handleButton={downloadData}
        loading={loading}
      />

      {openInfo && (
        <InfoModal
          open={openInfo}
          button="OK"
          content={statusMsg}
          handleButton={toggleOpenInfo}
        />
      )}
    </>
  );
};

export default Download;
